import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import axios from 'axios';

const BannerAvisoCuotas = () => {
  const { API, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [banner, setBanner] = useState(null);
  const [cerrado, setCerrado] = useState(false);

  useEffect(() => {
    if (user?.rol === 'estudiante' || user?.rol === 'pastor') {
      loadBanner();
    }
  }, [user]);

  const loadBanner = async () => {
    try {
      const token = localStorage.getItem('token') || localStorage.getItem('access_token');
      const res = await axios.get(`${API}/public/planes-cuotas/banner-aviso`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.mostrar_banner) {
        setBanner(res.data);
      }
    } catch {
      // silently fail
    }
  };

  if (!banner || cerrado) return null;

  const esVencida = banner.vencida;
  const diasRestantes = banner.dias_restantes;

  let bgColor, borderColor, iconColor, textColor;
  if (esVencida) {
    bgColor = 'bg-red-50'; borderColor = 'border-red-400'; iconColor = 'text-red-600'; textColor = 'text-red-800';
  } else if (diasRestantes <= 2) {
    bgColor = 'bg-red-50'; borderColor = 'border-red-300'; iconColor = 'text-red-500'; textColor = 'text-red-700';
  } else if (diasRestantes <= 5) {
    bgColor = 'bg-amber-50'; borderColor = 'border-amber-300'; iconColor = 'text-amber-500'; textColor = 'text-amber-700';
  } else {
    bgColor = 'bg-blue-50'; borderColor = 'border-blue-300'; iconColor = 'text-blue-500'; textColor = 'text-blue-700';
  }

  return (
    <div
      className={`${bgColor} border-l-4 ${borderColor} p-4 rounded-r-xl mb-4 relative animate-pulse-slow`}
      data-testid="banner-aviso-cuotas"
    >
      <button
        onClick={() => setCerrado(true)}
        className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
        data-testid="banner-cerrar-btn"
      >
        <i className="fas fa-times" />
      </button>
      <div className="flex items-center gap-3">
        <div className={`${iconColor} text-2xl`}>
          <i className={`fas ${esVencida ? 'fa-exclamation-triangle' : 'fa-clock'}`} />
        </div>
        <div className="flex-1">
          <p className={`font-bold ${textColor}`}>
            {esVencida ? 'Cuota vencida' : `Cuota ${banner.cuota_numero} por vencer`}
          </p>
          <p className={`text-sm ${textColor} opacity-80`}>
            {banner.mensaje} - <b>{banner.moneda} {banner.monto?.toLocaleString('es-UY', { minimumFractionDigits: 0 })}</b>
          </p>
        </div>
        <button
          onClick={() => navigate('/app/mis-cuotas')}
          className={`px-4 py-2 rounded-lg text-white text-sm font-medium ${
            esVencida ? 'bg-red-600 hover:bg-red-700' : 'bg-blue-600 hover:bg-blue-700'
          }`}
          data-testid="banner-ir-cuotas-btn"
        >
          <i className="fas fa-arrow-right mr-1" />
          {esVencida ? 'Pagar ahora' : 'Ver cuotas'}
        </button>
      </div>
    </div>
  );
};

export default BannerAvisoCuotas;
